module.exports = __webpack_public_path__ + "img/section3_9.f513a5b8.png";